namespace Gamification.Gamification {
    export interface ProdottiClassiRow {
        UserId?: number;
        TenantId?: number;
        IdProdottoClasse?: number;
        IdProdotto?: number;
        IdentifierClasse?: string;
        Nome?: string;
        Descrizione?: string;
        IdProdottoTenantId?: number;
        IdProdottoIdTipologiaProdotti?: number;
        IdProdottoIdentifierProdotto?: string;
        IdProdottoNome?: string;
        IdProdottoDescrizione?: string;
    }

    export namespace ProdottiClassiRow {
        export const idProperty = 'IdProdottoClasse';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.ProdottiClassi';
        export const lookupKey = 'Gamification.ProdottiClassi';

        export function getLookup(): Q.Lookup<ProdottiClassiRow> {
            return Q.getLookup<ProdottiClassiRow>('Gamification.ProdottiClassi');
        }
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoClasse = "IdProdottoClasse",
            IdProdotto = "IdProdotto",
            IdentifierClasse = "IdentifierClasse",
            Nome = "Nome",
            Descrizione = "Descrizione",
            IdProdottoTenantId = "IdProdottoTenantId",
            IdProdottoIdTipologiaProdotti = "IdProdottoIdTipologiaProdotti",
            IdProdottoIdentifierProdotto = "IdProdottoIdentifierProdotto",
            IdProdottoNome = "IdProdottoNome",
            IdProdottoDescrizione = "IdProdottoDescrizione"
        }
    }
}
